<template>
    <div class="d-flex">
        <div class="concepts-block" :class='{"active": search}'>
            <vx-input-group class="custom-input-group concepts-search">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        Concept Code
                    </div>
                </template>

                <div class="d-flex">
                    <div class="relative flex-grow">
                        <vs-input loading v-model="search"
                                  placeholder="Type at least 3 characters."
                                  class="has-icons"
                                  @input="fetchOptions"/>
                        <div class="icons">
                            <feather-icon v-if="search" icon="XIcon"
                                          svgClasses="h-6 w-6 cursor-pointer"
                                          @click="clearConceptSearch"
                                          style="opacity: 0.7; margin-right: 5px;"/>
                            <div v-if="conceptsLoading" class="vs-input__loading"
                                 style="margin-left: 5px;"/>
                        </div>
                    </div>
                    <vx-tooltip
                        class="help-tip"
                        position="top"
                        text="Embibe Knowledge Graph concept ID.">
                        <i class="material-icons notranslate"> help_outline </i>
                    </vx-tooltip>
                </div>
            </vx-input-group>
            <div class="relative">
                <div class="concept-results" v-if="conceptResults.length">
                    <div class="loader-block" v-if="isAddLoading" style="left: 50%; top: 50%; transform: translate(-50%, -50%);">
                        <div class="loading">
                            <div class="effect-1 effects"></div>
                            <div class="effect-2 effects"></div>
                            <div class="effect-3 effects"></div>
                        </div>
                    </div>
                    <div class="scroll">
                        <label v-for="option in conceptResults" :key="option.code"
                               class="result d-flex">
                            <div class="flex-grow">
                                <b>{{option.concept_id}}</b> (Grade {{option.grade}}): <span>{{option.title}}</span>
                            </div>
                            <vs-checkbox v-model="selectedConcepts" :vs-value="option" v-if="!isPrimary"/>
                            <vs-checkbox :vs-value="option" v-if="isPrimary" :value="primaryConcept === option" @change="handleCheckbox(option)"/>
                        </label>
                    </div>
                    <div class="buttons">
                        <vs-button radius icon-pack="feather"
                                   color="success"
                                   size="medium"
                                   icon="icon-check"
                                   @click="add"
                                   :disabled="!selectedConcepts.length && !primaryConcept"/>
                        <vs-button radius icon-pack="feather"
                                   color="danger"
                                   size="medium"
                                   icon="icon-x" @click="clearConceptSearch" class="mt-2"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from "axios";

    export default {
        name: "MetaSearch",
        props: {
            metaArr: Array,
            isPrimary: Boolean,
            url: String,
            addConcept: Function,
            addConcepts: Function,
            clearOtherSearches: Function,
            addPrimaryConcept: Function,
            addPrimaryConcepts: Function,
        },
        data() {
            return {
                search: "",
                conceptsLoading: false,
                conceptResults: [],
                selectedConcepts: [],
                cancelConceptSearch: null,
                isAddLoading: false,
                primaryConcept: null
            }
        },
        computed: {
            componentName: () => {
                return "MetaSearch"
            }
        },
        mounted() {

        },
        methods: {
            add() {
              if (this.isPrimary) {
                this.addSelectedConcept();
              } else {
                this.addSelectedConcepts();
              }
            },
            addSelectedConcept() {
              if (!this.primaryConcept) {
                return;
              }
              this.isAddLoading = true;
              this.addPrimaryConcept(this.primaryConcept);
            },
            addSelectedConcepts() {
                if (!this.selectedConcepts.length) {
                    return;
                }
                this.isAddLoading = true;
                if (this.addPrimaryConcepts) {
                  this.addPrimaryConcepts(this.selectedConcepts)
                } else {
                  this.addConcepts(this.selectedConcepts);
                }
            },
            handleCheckbox(item) {
              this.primaryConcept = this.primaryConcept === item ? null : item;
            },
            clearConceptSearch() {
                this.conceptResults = [];
                this.selectedConcepts = [];
                this.concept_id_search = "";
                this.search = "";
                this.isAddLoading = false;
                if (this.cancelConceptSearch && this.cancelConceptSearch.cancel) {
                    this.cancelConceptSearch.cancel({err: "Operation canceled by user action."});
                }
            },
            fetchOptions(search) {
                if (search.length < 3) return;
                clearTimeout(this.cDebounce);
                this.cDebounce = setTimeout(() => {
                    this.clearOtherSearches(this);
                    this.conceptResults = [];
                    if (this.cancelConceptSearch && this.cancelConceptSearch.cancel) {
                        this.cancelConceptSearch.cancel({err: "Operation canceled by new search.", newSearch: true});
                    }
                    this.conceptsLoading = true;
                    this.cancelConceptSearch = axios.CancelToken.source();
                    this.$axios.get(`${this.url}${search}`, {cancelToken: this.cancelConceptSearch.token}).then(res => {
                        if (res.data && res.data.length) {
                            this.conceptResults = res.data;
                        }
                        this.conceptsLoading = false;
                        this.cancelConceptSearch = null;
                    }).catch(e => {
                        console.log('catch_search', e)
                        this.conceptResults = [];
                        this.conceptsLoading = Boolean(e.message.newSearch);
                        this.cancelConceptSearch = null;
                    })
                }, 500)
            },
        },
    }
</script>
